/**
 * Descuentos del cierre, una línea por concepto (DSC-06..08; Mario, 3-nov: «se debe separar una linea por cargo, porque angrela
 * quiere saber el detalle»). Orden fijo: «Comisión», cada cargo del contrato y al final «Cargo por compra». En la base el cargo
 * por compra se llama «Cargo por uso»: el dato no cambia, solo se muestra distinto. Las líneas siempre suman comisión + cargo.
 * Sin dependencias ni tipos complejos (la prueba lo carga sin TypeScript).
 */
const r2 = (n: any) => Math.round((Number(n) || 0) * 100) / 100;
const COMISION = 'Comisión', COMPRA = 'Cargo por compra', GENERICO = 'Cargos';

/** «Cargo por uso» (nombre en la base) se muestra «Cargo por compra». */
export const conceptoVisible = (c: any): string => {
  const t = String(c || '').trim();
  return t.toLowerCase() === 'cargo por uso' ? COMPRA : t;
};

/** DSC-06: [{ concepto, usd }] de unos `totales` del núcleo { comision, cargo, cargos [{ concepto, monto }] }. */
export const descuentosDe = (totales: any): any[] => {
  if (!totales) return [];
  const out: any[] = [{ concepto: COMISION, usd: r2(totales.comision) }];
  const cargo = r2(totales.cargo);
  const cargos = (Array.isArray(totales.cargos) ? totales.cargos : []).filter((c: any) => r2(c && c.monto) !== 0);
  if (!cargos.length) {
    if (cargo !== 0) out.push({ concepto: GENERICO, usd: cargo });
    return out;
  }
  let compra = 0, suma = 0;
  for (const c of cargos) {
    const nombre = conceptoVisible(c.concepto), monto = r2(c.monto);
    suma += monto;
    if (nombre === COMPRA) compra = r2(compra + monto); else out.push({ concepto: nombre, usd: monto });
  }
  // lo que `cargos` no explica va al cargo por compra (el núcleo hace igual en `desgloseDeCargo`)
  compra = r2(compra + (cargo - r2(suma)));
  if (compra !== 0) out.push({ concepto: COMPRA, usd: compra });
  return out;
};

/** DSC-06: suma por concepto de varias liquidaciones (pie de tabla y tarjeta de totales), en el mismo orden fijo. */
export const sumarDescuentos = (lista: any[]): any[] => {
  const por = new Map();
  for (const t of lista || []) for (const d of descuentosDe(t)) por.set(d.concepto, r2((por.get(d.concepto) || 0) + d.usd));
  const nombres = Array.from(por.keys());
  const medio = nombres.filter((n) => n !== COMISION && n !== COMPRA);
  const orden = [...nombres.filter((n) => n === COMISION), ...medio, ...nombres.filter((n) => n === COMPRA)];
  return orden.map((concepto) => ({ concepto, usd: por.get(concepto) || 0 }));
};

/** DSC-10: el Bs de un monto con la tasa de su tanda; sin tasa, null (la pieza muestra USD, no se inventa un Bs). */
export const bsConTasa = (usd: any, tasa: any) => (Number(tasa) > 0 ? r2((Number(usd) || 0) * Number(tasa)) : null);
